import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "manager-residency-requests__detail" }
const _hoisted_2 = { class: "manager-residency-requests__detail-header" }
const _hoisted_3 = { class: "manager-residency-requests__detail-header-section" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "manager-residency-requests__detail-header-section" }
const _hoisted_6 = { class: "manager-residency-requests__detail-status-select" }
const _hoisted_7 = { class: "manager-residency-requests__detail-status-select-label" }
const _hoisted_8 = {
  key: 0,
  class: "manager-residency-requests__detail-header-section-divider"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "manager-residency-requests__detail-tabs-container" }
const _hoisted_12 = { class: "general-information" }
const _hoisted_13 = { class: "general-information__section" }
const _hoisted_14 = { class: "general-information__fields" }
const _hoisted_15 = { class: "general-information__field" }
const _hoisted_16 = { class: "general-information__field-value" }
const _hoisted_17 = {
  key: 0,
  class: "general-information__field"
}
const _hoisted_18 = { class: "general-information__field-value" }
const _hoisted_19 = {
  key: 1,
  class: "general-information__field"
}
const _hoisted_20 = { class: "general-information__field-value" }
const _hoisted_21 = {
  key: 2,
  class: "general-information__field"
}
const _hoisted_22 = { class: "general-information__field-value" }
const _hoisted_23 = {
  key: 3,
  class: "general-information__field"
}
const _hoisted_24 = { class: "general-information__field-value" }
const _hoisted_25 = {
  key: 4,
  class: "general-information__field"
}
const _hoisted_26 = { class: "general-information__field-value" }
const _hoisted_27 = {
  key: 5,
  class: "general-information__field"
}
const _hoisted_28 = { class: "general-information__field-value" }
const _hoisted_29 = {
  key: 6,
  class: "general-information__field"
}
const _hoisted_30 = { class: "general-information__field-value" }
const _hoisted_31 = {
  key: 7,
  class: "general-information__field"
}
const _hoisted_32 = { class: "general-information__field-value" }
const _hoisted_33 = {
  key: 8,
  class: "general-information__field"
}
const _hoisted_34 = { class: "general-information__field-value" }
const _hoisted_35 = {
  key: 9,
  class: "general-information__field"
}
const _hoisted_36 = {
  key: 0,
  class: "general-information__field-value"
}
const _hoisted_37 = {
  key: 1,
  class: "general-information__field-list"
}
const _hoisted_38 = { class: "general-information__field-value" }
const _hoisted_39 = {
  key: 10,
  class: "general-information__field"
}
const _hoisted_40 = {
  key: 0,
  class: "general-information__field-value"
}
const _hoisted_41 = {
  key: 1,
  class: "general-information__field-list"
}
const _hoisted_42 = { class: "general-information__field-value" }
const _hoisted_43 = {
  key: 11,
  class: "general-information__field"
}
const _hoisted_44 = { class: "general-information__field-value" }
const _hoisted_45 = {
  key: 12,
  class: "general-information__field"
}
const _hoisted_46 = { class: "general-information__field-value" }
const _hoisted_47 = {
  key: 13,
  class: "general-information__field"
}
const _hoisted_48 = { class: "general-information__field-value" }
const _hoisted_49 = {
  key: 14,
  class: "general-information__field"
}
const _hoisted_50 = { class: "general-information__field-value" }
const _hoisted_51 = {
  key: 15,
  class: "general-information__field"
}
const _hoisted_52 = { class: "general-information__field-value" }
const _hoisted_53 = {
  key: 16,
  class: "general-information__field"
}
const _hoisted_54 = { class: "general-information__field-value" }
const _hoisted_55 = {
  key: 17,
  class: "general-information__field"
}
const _hoisted_56 = { class: "general-information__field-value" }
const _hoisted_57 = {
  key: 18,
  class: "general-information__field"
}
const _hoisted_58 = { class: "general-information__field-value" }
const _hoisted_59 = {
  key: 19,
  class: "general-information__field"
}
const _hoisted_60 = {
  key: 0,
  class: "general-information__field-value"
}
const _hoisted_61 = {
  key: 1,
  class: "general-information__field-list"
}
const _hoisted_62 = { class: "general-information__field-value" }
const _hoisted_63 = {
  key: 20,
  class: "general-information__field"
}
const _hoisted_64 = { class: "general-information__field-value" }
const _hoisted_65 = { class: "general-information__section" }
const _hoisted_66 = { class: "general-information__fields" }
const _hoisted_67 = { class: "general-information__field" }
const _hoisted_68 = { class: "general-information__field-value" }
const _hoisted_69 = {
  key: 0,
  class: "general-information__field"
}
const _hoisted_70 = { class: "general-information__field-value" }
const _hoisted_71 = { class: "general-information__field" }
const _hoisted_72 = { class: "general-information__field-value" }
const _hoisted_73 = { class: "general-information__field" }
const _hoisted_74 = { class: "general-information__field-value" }
const _hoisted_75 = {
  key: 0,
  class: "general-information__section"
}
const _hoisted_76 = { class: "general-information__fields" }
const _hoisted_77 = ["href"]
const _hoisted_78 = { class: "manager-residency-requests__detail-doc-icon-wrap" }
const _hoisted_79 = ["src", "alt"]
const _hoisted_80 = { class: "manager-residency-requests__detail-doc-body" }
const _hoisted_81 = { class: "manager-residency-requests__detail-doc-name" }
const _hoisted_82 = { class: "manager-residency-requests__detail-doc-meta" }
const _hoisted_83 = { class: "manager-residency-requests__detail-doc-meta-format" }
const _hoisted_84 = { class: "manager-residency-requests__detail-doc-meta-size" }
const _hoisted_85 = {
  class: "manager-residency-requests__detail-doc-dl",
  "aria-hidden": "true"
}
const _hoisted_86 = ["src"]
const _hoisted_87 = {
  key: 0,
  class: "general-information__field"
}
const _hoisted_88 = { class: "general-information__section" }
const _hoisted_89 = { class: "general-information__textarea-counter-wrapper" }
const _hoisted_90 = { class: "general-information__textarea-counter" }
const _hoisted_91 = { class: "manager-residency-requests__detail-update-buttons" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "manager-residency-requests__table-wrapper personal-area-table-wrapper" }
const _hoisted_95 = { class: "manager-residency-requests__detail-history-date" }
const _hoisted_96 = { class: "personal-area-table__detail-history-status" }
const _hoisted_97 = ["src"]
const _hoisted_98 = {
  key: 1,
  class: "manager-requests__detail-no-history"
}
const _hoisted_99 = { class: "reply-drawer__close-trigger" }
const _hoisted_100 = { class: "reply-drawer__textarea-counter-wrapper" }
const _hoisted_101 = { class: "reply-drawer__textarea-counter" }
const _hoisted_102 = ["disabled"]

import { reactive, ref, watch, computed, nextTick } from 'vue';
import Pagination from '../../Pagination.vue';
import dayjs from 'dayjs';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import type {
  Request,
  PermissionFormData,
  ApiStatusResponse,
  ApiStatus,
} from '../types';
import { CloseOutlined } from '@ant-design/icons-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import FormFileUpload from '@/js/components/form/form-file-upload.vue';
import ArrowDownIcon from '@/js/components/icons/ArrowDownIcon.vue';
import {
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Row as ARow,
  Col as ACol,
  Space as ASpace,
  Textarea as ATextarea,
  Dropdown as ADropdown,
  Menu as AMenu,
  MenuItem as AMenuItem,
} from 'ant-design-vue';

const COMMENT_MAX_LENGTH = 512;
const HISTORY_PAGE_SIZE = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'RequestDetail',
  props: {
    request: {},
    loading: { type: Boolean }
  },
  emits: ["close", "status-updated", "reply", "back"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const activeTab = ref('info');
const historyPage = ref(1);
const selectedStatus = ref<ApiStatusResponse>(props.request.status);
const noteText = ref(props.request.adminMessage || '');
const replyOpen = ref(false);

const formRef = ref<FormInstance>();
const documentsUploadRef = ref<InstanceType<typeof FormFileUpload> | null>(null);
const documentItems = ref([]);
const isSubmitting = ref(false);

const initialFormState = () => ({
  comment: '',
});

const form = reactive(initialFormState());

const commentLength = computed(() => form.comment.length);

const rules: Record<string, Rule[]> = {
  comment: [
    {
      required: false,
      whitespace: true,
      message: 'Введите комментарий',
    },
  ],
};

const isRequiredFieldsFilled = computed(
  () => form.comment.trim().length > 0 || documentItems.value.length > 0,
);

const isSubmitDisabled = computed(() => isSubmitting.value || !isRequiredFieldsFilled.value);

const historyTotalCount = computed(() => props.request.historyUpdate?.length ?? 0);

const paginatedHistory = computed(() => {
  if (!props.request.historyUpdate?.length) {
    return [];
  }

  const start = (historyPage.value - 1) * HISTORY_PAGE_SIZE;
  const end = start + HISTORY_PAGE_SIZE;

  return props.request.historyUpdate.slice(start, end);
});

const statusOptions = computed(() => {
  if (!props.request?.statuses || props.request?.statuses.length < 1) return [];
  return props.request.statuses.map((item) => ({
    value: item.id,
    label: item.name,
  }));
});

const hasStatusChanged = computed(() => {
  return (
    selectedStatus.value !== props.request.status ||
    noteText.value !== (props.request.adminMessage || '')
  );
});

watch(
  () => props.request.status,
  (newStatus) => {
    selectedStatus.value = newStatus;
  },
);
watch(
  () => props.request.adminMessage,
  (newText) => {
    noteText.value = newText || '';
  },
);

const getFileExtension = (file: { name: string; url: string }) => {
  const source = file.name || file.url;

  return source.split('.').pop()?.split('?')[0].toLowerCase() || 'file';
};

const getFileIcon = (file: { name: string; url: string }) => {
  const ext = getFileExtension(file);

  const availableIcons = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar'];

  return availableIcons.includes(ext)
    ? `${ICONS_BASE}/doc/doc_${ext}.svg`
    : '${ICONS_BASE}/doc/doc_txt.svg';
};

function getStatusClass(stat?: ApiStatus | null, cl?: string): string {
  const baseClass = cl ?? 'personal-area-table__status';

  if (!stat) return baseClass;

  const extStatusClass = ` ${baseClass}--${stat.toString().toLowerCase().replace(/\s+/g, '-')}`;
  return baseClass + extStatusClass;
}

function handleHistoryPageChange(page: number) {
  historyPage.value = page;
}

function changeStatus({ key }: { key: string | number }) {
  const currentStatus = props.request.statuses?.find((item) => item.id === key);
  if (currentStatus) selectedStatus.value = currentStatus;
}

function saveStatus() {
  if (hasStatusChanged.value) {
    emit('status-updated', {
      status:
        selectedStatus.value.id !== props.request.status.id ? selectedStatus.value : undefined,
      text: noteText.value !== props.request.adminMessage ? noteText.value : undefined,
    });
  }
}

function resetStatus() {
  selectedStatus.value = props.request.status;
  noteText.value = props.request.adminMessage || '';
}

const resetFormState = () => {
  Object.assign(form, initialFormState());
  documentItems.value = [];
  documentsUploadRef.value?.reset();
  nextTick(() => {
    formRef.value?.clearValidate();
  });
};

const onCloseReply = () => {
  resetFormState();
  replyOpen.value = false;
};

const onSubmit = async () => {
  if (!formRef.value) {
    return;
  }

  try {
    await formRef.value.validate();
  } catch {
    return;
  }

  isSubmitting.value = true;
  documentsUploadRef.value?.setSubmittingState(true);

  try {
    const readyFiles = documentsUploadRef.value?.getReadyFiles() ?? [];

    emit('reply', {
      comment: form.comment,
      files: readyFiles,
    });
    isSubmitting.value = false;
    onCloseReply();
  } catch (err) {
    console.error('Ошибка отправки ответа:', err);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "manager-residency-requests__detail-back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
          }, [
            _createElementVNode("img", {
              src: `${_unref(ICONS_BASE)}/arrow-back-icon.svg`,
              alt: "",
              class: "manager-residency-requests__detail-back-icon"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("h2", null, "Заявка " + _toDisplayString(__props.request?.id), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ADropdown), null, {
            overlay: _withCtx(() => [
              _createVNode(_unref(AMenu), { onClick: changeStatus }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(AMenuItem), {
                      key: item?.value as string,
                      class: _normalizeClass({
                'selected':
                  item.value === selectedStatus.value.id,
              })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["manager-residency-requests__detail-status-select-option", {
                  'manager-residency-requests__detail-status-select-option--selected':
                    item.value === selectedStatus.value.id,
                }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(getStatusClass(
                    item.value,
                    'manager-residency-requests__detail-status-select-dot',
                  )
                    )
                          }, null, 2),
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(getStatusClass(
              selectedStatus.value.id,
              'manager-residency-requests__detail-status-select-dot',
            )
              )
                }, null, 2),
                _createElementVNode("span", _hoisted_7, _toDisplayString(selectedStatus.value.name), 1),
                _createVNode(ArrowDownIcon, { class: "manager-residency-requests__detail-status-select-icon" })
              ])
            ]),
            _: 1
          }),
          (activeTab.value !== 'history')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true),
          (activeTab.value !== 'history')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-secondary btn-medium manager-residency-requests__detail-reply-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (replyOpen.value = true)),
                disabled: __props.loading,
                label: "Ответ заявителю"
              }, [
                _createElementVNode("img", {
                  src: `${_unref(ICONS_BASE)}/reply-icon.svg`,
                  alt: "",
                  class: "manager-residency-requests__detail-reply-button-icon"
                }, null, 8, _hoisted_10),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Ответ заявителю", -1))
              ], 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(Tabs), {
          value: activeTab.value,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Tab), { value: "info" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Основная информация", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(Tab), { value: "history" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("История изменений", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanels), null, {
              default: _withCtx(() => [
                _createVNode(_unref(TabPanel), { value: "info" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "general-information__section-title" }, "Общее", -1)),
                        _createElementVNode("ul", _hoisted_14, [
                          _createElementVNode("li", _hoisted_15, [
                            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "general-information__field-label" }, "Название компании", -1)),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(__props.request.companyName || '—'), 1)
                          ]),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'shortNameCompany'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "general-information__field-label" }, "Сокращенное название юр. лица или ИП", -1)),
                                _createElementVNode("p", _hoisted_18, _toDisplayString(__props.request.shortNameCompany || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'legalForm'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "general-information__field-label" }, "Организационно-правовая форма", -1)),
                                _createElementVNode("p", _hoisted_20, _toDisplayString(__props.request.legalForm || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'ogrn'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "general-information__field-label" }, "ОГРН/ОГРНИП", -1)),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(__props.request.ogrn || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'address'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "general-information__field-label" }, "Адрес местонахождения", -1)),
                                _createElementVNode("p", _hoisted_24, _toDisplayString(__props.request.address || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'registrationAuthority'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "general-information__field-label" }, "Наименование органа осуществляющего государственную регистрацию", -1)),
                                _createElementVNode("p", _hoisted_26, _toDisplayString(__props.request.registrationAuthority || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'registrationDate'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "general-information__field-label" }, "Дата регистрации", -1)),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(__props.request.registrationDate || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'businessArea'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "general-information__field-label" }, "Сфера деятельности", -1)),
                                _createElementVNode("p", _hoisted_30, _toDisplayString(__props.request.businessArea || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'areaActivity'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "general-information__field-label" }, "Сфера деятельности", -1)),
                                _createElementVNode("p", _hoisted_32, _toDisplayString(__props.request.areaActivity || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'cluster'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "general-information__field-label" }, "Кластер", -1)),
                                _createElementVNode("p", _hoisted_34, _toDisplayString(__props.request.cluster || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'educationType'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "general-information__field-label" }, "Виды, уровни образования, планируемые к осуществлению на территории ИНТЦ", -1)),
                                (__props.request.educationType?.length === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, " — "))
                                  : (_openBlock(), _createElementBlock("ul", _hoisted_37, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.educationType, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: item as string,
                                          class: "general-information__field-list-item"
                                        }, [
                                          _createElementVNode("p", _hoisted_38, _toDisplayString('- ' + item), 1)
                                        ]))
                                      }), 128))
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'implementationForm'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "general-information__field-label" }, "Формы реализации образовательной деятельности на территории ИНТЦ", -1)),
                                (__props.request.implementationForm?.length === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, " — "))
                                  : (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.implementationForm, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: item as string,
                                          class: "general-information__field-list-item"
                                        }, [
                                          _createElementVNode("p", _hoisted_42, _toDisplayString('- ' + item), 1)
                                        ]))
                                      }), 128))
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'projectDescription'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "general-information__field-label" }, "Описание проекта", -1)),
                                _createElementVNode("p", _hoisted_44, _toDisplayString(__props.request.projectDescription || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'programDescription'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "general-information__field-label" }, "Описание проекта", -1)),
                                _createElementVNode("p", _hoisted_46, _toDisplayString(__props.request.programDescription || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'premises'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "general-information__field-label" }, "Помещение", -1)),
                                _createElementVNode("p", _hoisted_48, _toDisplayString(__props.request.premises || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'dateEvent'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "general-information__field-label" }, "Дата мероприятия", -1)),
                                _createElementVNode("p", _hoisted_50, _toDisplayString(__props.request.dateEvent || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'timeEvent'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "general-information__field-label" }, "Время начала", -1)),
                                _createElementVNode("p", _hoisted_52, _toDisplayString(__props.request.timeEvent || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'durationEvent'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "general-information__field-label" }, "Продолжительность", -1)),
                                _createElementVNode("p", _hoisted_54, _toDisplayString(__props.request.durationEvent || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'format'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                                _cache[28] || (_cache[28] = _createElementVNode("p", { class: "general-information__field-label" }, "Формат мероприятия", -1)),
                                _createElementVNode("p", _hoisted_56, _toDisplayString(__props.request.format || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'countParticipants'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "general-information__field-label" }, "Количество участников", -1)),
                                _createElementVNode("p", _hoisted_58, _toDisplayString(__props.request.countParticipants || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'additionalServices'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "general-information__field-label" }, "Доп. услуги и оборудование", -1)),
                                (__props.request.additionalServices?.length === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_60, " — "))
                                  : (_openBlock(), _createElementBlock("ul", _hoisted_61, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.additionalServices, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: item as string,
                                          class: "general-information__field-list-item"
                                        }, [
                                          _createElementVNode("p", _hoisted_62, _toDisplayString('- ' + item), 1)
                                        ]))
                                      }), 128))
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'wishes'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_63, [
                                _cache[31] || (_cache[31] = _createElementVNode("p", { class: "general-information__field-label" }, "Пожелания", -1)),
                                _createElementVNode("p", _hoisted_64, _toDisplayString(__props.request.wishes || '—'), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "general-information__section-title" }, "Контактное лицо", -1)),
                        _createElementVNode("ul", _hoisted_66, [
                          _createElementVNode("li", _hoisted_67, [
                            _cache[33] || (_cache[33] = _createElementVNode("p", { class: "general-information__field-label" }, "ФИО", -1)),
                            _createElementVNode("p", _hoisted_68, _toDisplayString(__props.request.fio || '—'), 1)
                          ]),
                          (Object.prototype.hasOwnProperty.call(__props.request, 'workPosition'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                _cache[34] || (_cache[34] = _createElementVNode("p", { class: "general-information__field-label" }, "Должность", -1)),
                                _createElementVNode("p", _hoisted_70, _toDisplayString(__props.request.workPosition || '—'), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", _hoisted_71, [
                            _cache[35] || (_cache[35] = _createElementVNode("p", { class: "general-information__field-label" }, "Телефон", -1)),
                            _createElementVNode("p", _hoisted_72, _toDisplayString(__props.request.phone || '—'), 1)
                          ]),
                          _createElementVNode("li", _hoisted_73, [
                            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "general-information__field-label" }, "Email", -1)),
                            _createElementVNode("p", _hoisted_74, _toDisplayString(__props.request.email || '—'), 1)
                          ])
                        ])
                      ]),
                      (__props.request?.files)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "general-information__section-title" }, "Документы", -1)),
                            _createElementVNode("ul", _hoisted_76, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.files, (file) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "general-information__field",
                                  key: file.url
                                }, [
                                  _createElementVNode("a", {
                                    href: file.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "manager-residency-requests__detail-doc-row"
                                  }, [
                                    _createElementVNode("span", _hoisted_78, [
                                      _createElementVNode("img", {
                                        class: "manager-residency-requests__detail-doc-icon",
                                        src: getFileIcon(file),
                                        alt: getFileExtension(file).toUpperCase()
                                      }, null, 8, _hoisted_79)
                                    ]),
                                    _createElementVNode("span", _hoisted_80, [
                                      _createElementVNode("span", _hoisted_81, _toDisplayString(file.name), 1),
                                      _createElementVNode("span", _hoisted_82, [
                                        _createElementVNode("span", _hoisted_83, _toDisplayString(getFileExtension(file).toUpperCase()), 1),
                                        _cache[38] || (_cache[38] = _createElementVNode("span", {
                                          class: "manager-residency-requests__detail-doc-meta-sep",
                                          "aria-hidden": "true"
                                        }, " / ", -1)),
                                        _createElementVNode("span", _hoisted_84, _toDisplayString(file.size), 1)
                                      ])
                                    ]),
                                    _createElementVNode("span", _hoisted_85, [
                                      _createElementVNode("img", {
                                        src: `${_unref(ICONS_BASE)}/download-icon.svg`,
                                        alt: "",
                                        width: "24",
                                        height: "24"
                                      }, null, 8, _hoisted_86)
                                    ])
                                  ], 8, _hoisted_77)
                                ]))
                              }), 128)),
                              (!__props.request.files?.length)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_87, [...(_cache[39] || (_cache[39] = [
                                    _createElementVNode("p", { class: "general-information__field-value" }, "Документы отсутствуют", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_88, [
                        _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "general-information__section-title" }, "Прочее", -1)),
                        _createElementVNode("div", null, [
                          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "general-information__field-label" }, "Комментарий*", -1)),
                          _createVNode(_unref(AFormItem), { class: "stc-ant-field-skin general-information__message-field" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ATextarea), {
                                value: noteText.value,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((noteText).value = $event)),
                                class: "general-information__textarea",
                                rows: 8,
                                maxlength: COMMENT_MAX_LENGTH,
                                placeholder: "Введите комментарий"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_89, [
                            _cache[41] || (_cache[41] = _createElementVNode("p", { class: "general-information__field-label" }, "*не обязателен", -1)),
                            _createElementVNode("div", _hoisted_90, _toDisplayString(noteText.value.length) + " / " + _toDisplayString(COMMENT_MAX_LENGTH), 1)
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            (hasStatusChanged.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: resetStatus,
                                  disabled: __props.loading,
                                  class: "btn btn-secondary btn-medium"
                                }, "Отмена", 8, _hoisted_92))
                              : _createCommentVNode("", true),
                            (hasStatusChanged.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: saveStatus,
                                  class: "btn btn-primary btn-medium manager-residency-requests__detail-save-btn",
                                  disabled: __props.loading
                                }, "Сохранить", 8, _hoisted_93))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TabPanel), { value: "history" }, {
                  default: _withCtx(() => [
                    (__props.request.historyUpdate?.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_unref(DataTable), {
                              value: paginatedHistory.value,
                              scrollable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Column), { header: "Дата / время" }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("span", _hoisted_95, _toDisplayString(_unref(dayjs)(data.date).format('DD.MM.YYYY / HH:mm')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(Column), { header: "Изменение статуса" }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("p", _hoisted_96, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(getStatusClass(data?.oldStatus?.id ?? null))
                                      }, _toDisplayString(data.oldStatus.name), 3),
                                      _createElementVNode("img", {
                                        src: `${_unref(ICONS_BASE)}/arrow-right-transform.svg`,
                                        alt: "",
                                        class: "personal-area-table__transform-arrow-icon"
                                      }, null, 8, _hoisted_97),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(getStatusClass(data?.newStatus?.id ?? null))
                                      }, _toDisplayString(data.newStatus.name), 3)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(Column), { header: "Автор" }, {
                                  body: _withCtx(({ data }) => [
                                    _createTextVNode(_toDisplayString(data.userChange || ''), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _createVNode(Pagination, {
                            modelValue: historyPage.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((historyPage).value = $event)),
                            "total-count": historyTotalCount.value,
                            "page-size": HISTORY_PAGE_SIZE,
                            onChange: handleHistoryPageChange
                          }, null, 8, ["modelValue", "total-count"])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_98, " История статусов отсутствует "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_unref(ADrawer), {
      width: 800,
      open: replyOpen.value,
      class: "reply-drawer",
      "body-style": { paddingBottom: '24px' },
      "footer-style": { textAlign: 'left' },
      onClose: onCloseReply
    }, {
      title: _withCtx(() => [...(_cache[44] || (_cache[44] = [
        _createElementVNode("div", { class: "reply-drawer__header-shell" }, [
          _createElementVNode("div", { class: "reply-drawer__header-overline" }, "Ответ заявителю")
        ], -1)
      ]))]),
      closeIcon: _withCtx(() => [
        _createElementVNode("span", _hoisted_99, [
          _createVNode(_unref(CloseOutlined))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(ARow), {
          align: "middle",
          justify: "space-between",
          class: "reply-drawer__toolbar"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ACol), {
              span: 24,
              class: "reply-drawer__toolbar-submit"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASpace), null, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline",
                      onClick: onCloseReply
                    }, "Отмена"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: onSubmit,
                      disabled: isSubmitDisabled.value
                    }, _toDisplayString(isSubmitting.value ? 'Отправка…' : 'Отправить'), 9, _hoisted_102)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(AForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "reply-drawer__field-label" }, "Комментарий*", -1)),
            _createVNode(_unref(AFormItem), {
              class: "stc-ant-field-skin reply-drawer__message-field",
              name: "comment"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ATextarea), {
                  value: form.comment,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.comment) = $event)),
                  class: "reply-drawer__textarea",
                  rows: 8,
                  maxlength: COMMENT_MAX_LENGTH,
                  placeholder: "Введите комментарий"
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_100, [
                  _cache[45] || (_cache[45] = _createElementVNode("p", { class: "reply-drawer__field-label" }, "*не обязателен", -1)),
                  _createElementVNode("div", _hoisted_101, _toDisplayString(commentLength.value) + " / " + _toDisplayString(COMMENT_MAX_LENGTH), 1)
                ])
              ]),
              _: 1
            }),
            _cache[47] || (_cache[47] = _createElementVNode("hr", { class: "reply-drawer__divider" }, null, -1)),
            _createVNode(FormFileUpload, {
              ref_key: "documentsUploadRef",
              ref: documentsUploadRef,
              modelValue: documentItems.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((documentItems).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})